import React, { useState,useContext } from "react";

import { LayoutContext,SideBarContext } from '_context/LayoutContext';

import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';

import kt_geo_master from 'resources/imgs/kt_geo_master.png';
import banner_contract from 'resources/imgs/data/banner_contract.png';
import banner_onenavi from 'resources/imgs/data/banner_onenavi.png';

const LNB = () => {

    const { lnb, toggle } = useContext(SideBarContext);
    const { chgStatus } = useContext(LayoutContext);

    return (
        <div className={lnb?"wrapLnb view":"wrapLnb"}>
		 <div className="inner">
			<div className="header">
				 <img src={kt_geo_master} alt="kt Geo Master"/> 
				<button className="btnsLnb btnClose" onClick={() => toggle("lnb")}>닫기</button>
			</div>
			<div className="plugin-scrollbar-bd">
				<div className="plugin-scrollbar">
					<div className="list1">
						<ul>
							<li><a onClick={()=>{chgStatus("search");toggle("lnb");}}><span className="btnsLnb ic1"></span>검색</a></li>
							<li><a onClick={()=>{chgStatus("rp");toggle("lnb");}}><span className="btnsLnb ic2"></span>길찾기</a></li>
							<li><a href="#" className="disabled"><span className="btnsLnb ic3"></span>버스</a></li>
							<li><a href="#" className="disabled"><span className="btnsLnb ic4"></span>지하철</a></li>
						</ul>
						{/* <ul>
							<li><a href="#" ><span className="btnsLnb ic5"></span>내 즐겨찾기</a></li>
							<li><a href="#"><span className="btnsLnb ic6"></span>신규 장소등록</a></li>
							<li><a href="#" ><span className="btnsLnb ic7"></span>처리내역 조회</a></li>
						</ul> */}
					</div>
					<div className="list1 small">
						<ul>
							<li>지도범례</li>
							<li><a href="https://apilink.kt.co.kr/Geomaster" target="_blank">지도 Open API</a></li>
							<li>KT GEO Master 소개</li>
						</ul>
					</div>
					<div className="banner">
						<ul>
							<li><a href="https://apilink.kt.co.kr/Geomaster" target="_blank">
                            <img src={banner_contract} alt="KT GIS 플랫폼 서비스를 경험하세요! 신규 계약안내"/></a></li>
							<li><img src={banner_onenavi} alt="당신이 찾는 모든 길 안내 - 원내비 다운로드" /* usemap="#image_map_onenavi" *//></li>
							<map name="image_map_onenavi">
								<area coords="11,80,133,113" shape="rect" alt="google play" title="google play" href=""/>
								<area coords="11,116,133,149" shape="rect" alt="apple appstore" title="apple appstore" href=""/>
							</map>
						</ul>
					</div>

				</div>
			</div>
		</div>
	    </div>
    );
  };
  
  export default LNB;